<template>
  <div class="invoice-detail-wrap" v-loading="pageLoading">
    <div class="invoice-detail-left">
      <!-- 状态栏 -->
      <detail-header
        class="apply-detail-content"
        :data="invoiceType"
      ></detail-header>
      <!-- 详细信息 -->
      <detail-invice-info
        class="apply-detail-content"
        :data="invoiceDataList"
        :title="'详细信息'"
      ></detail-invice-info>
      <!-- 邮寄地址 -->
      <detail-invice-info
        class="apply-detail-content"
        :isSign="true"
        :data="invoiceAddressList"
        :title="'邮寄地址'"
        :routeOperate="routeOperate"
        @toggleInvoiceImg="toggleInvoiceImg"
        @downloadInvoiceImg="downloadInvoiceImg"
      ></detail-invice-info>
      <!-- 物流信息 -->
      <detail-invice-info
        v-if="invoiceType.name === '待邮寄' || invoiceType.name === '发票已寄出'"
        class="apply-detail-content"
        :data="invoiceAddressListYouJi"
        :title="'物流信息'"
        :routeOperate="routeOperate"
        @toggleInvoiceImg="toggleInvoiceImg"
        @downloadInvoiceImg="downloadInvoiceImg"
      ></detail-invice-info>
      <!-- 审核意见-驳回 -->
      <detail-invice-info
        v-if="routeOperate === 4"
        class="apply-detail-content"
        :data="invoiceReject"
        :title="'审核意见'"
        :routeOperate="routeOperate"
      ></detail-invice-info>
      <!-- 发票文件 -->
      <!-- // 操作类型，1:审核；2:填写物流信息；3、查看-已寄出；4、查看-驳回 -->
      <div v-if="routeOperate == 1 || routeOperate == 2" class="apply-detail-content apply-detail-bottom apply-detail-bottom-file">
        <div class="etail-bottom-title">
          <h4 class="apply-detail-bottom__title apply-detail-bottom__detail">发票文件</h4>
        </div>
        <div class="invoice-item__value detail-content-bolck">
          <span class="invoice-label" :class="{'label-request': routeOperate === 1}">发票文件</span>
          <!-- 审核-上传文件 -->
          <yjh-upload
            v-if="routeOperate === 1"
            :url="baseAPI + '/invoice/do_add'"
            :stopUpload="true"
            :max="10"
            :fileType="['JPG', 'JPEG', 'PNG', 'BMP']"
            overSizeToast="上传文件大小不能超过10M"
            @changeTips="changeTips"
            @beforeUpload="handleUpload"
          ></yjh-upload>
          <!-- 填写物流信息-发票预览 -->
          <div v-else class="invoice-log">
            <!-- tableData.invoice_file_path -->
            <img :src="detailData.invoice_file_path" alt="发票文件">
            <div class="invoice-detail-right__btn invoice-log__btn" @click.stop="toggleFullImg(true, detailData.invoice_file_path)">预览</div>
          </div>
          <!-- 审核-上传文件失败 -->
          <div class="invoice-file-tips" v-if="showFileRequerst">
            <i class="iconfont icontishi"></i>上传失败，请重新上传
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="apply-detail-content apply-detail-bottom">
        <div class="etail-bottom-title">
          <h4 class="apply-detail-bottom__title apply-detail-bottom__detail">账单明细（{{tableData.length}}）</h4>
          <div v-if="tableData.length > 0" class="apply-detail-btn yjh-active" @click="changeExport">导出明细</div>
        </div>
        <pageTable
          :loading="tableLoading"
          :col="innerCol"
          :data="tableData"
          :total="total"
          :pageIndex="page"
          :pageSize="pageSize"
          :titleRowHeight="34"
          :rowHeight="34"
          :showPage="false"
          :isVerticalResize="false"
        ></pageTable>
      </div>
    </div>
    <!-- 右侧时间轴 -->
    <div class="invoice-detail-right" v-show="!pageLoading">
      <div class="invoice-detail-right-content">
        <div class="detail-right-content">
          <div class="detail-right-content__top">
            <h4 class="invoice-detail-right__title">审核记录</h4>
            <Timeline class="invoice-detail-time-content">
              <TimelineItem v-for="(item, index) in detailData.apply_check_list" :key="index" :class="{'time-last': index === 0}">
                <p class="invoice-detail-time">{{item.check_time}}</p>
                <p class="invoice-detail-time-type">{{item.check_status}}</p>
                <p class="invoice-detail-time-tips" v-if="item.check_text">驳回原因：{{item.check_text}}</p>
              </TimelineItem>
            </Timeline>
          </div>
          <!-- 营业执照 -->
          <div class="detail-right-content__bottom">
            <h4 class="invoice-detail-right__title">营业执照</h4>
            <img class="invoice-detail-img" :src="detailData.accessory_url" alt="营业执照">
            <div class="invoice-detail-img__btn">
              <span class="invoice-detail-right__btn" @click.stop="toggleFullImg(true, detailData.accessory_url)">预览</span>
              <span class="invoice-detail-right__btn" @click.stop="downloadImg">下载</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 审核按钮 -->
    <div class="invoice-footer" v-show="!pageLoading" v-if="routeOperate <= 2">
      <div class="invoice-footer-content">
        <!-- 审核 -->
        <div class="invoice-footer-left" v-if="routeOperate === 1">
          <Button :disabled="btnDisabled" class="invoice-footer-btn" @click="toggleDelDiag(true)">驳回</Button>
          <Button type="primary" :disabled="btnDisabled" class="invoice-footer-btn" @click="invoicePost('1')">通过</Button>
        </div>
        <!-- 填写物流信息 -->
        <div class="invoice-footer-left" v-else>
          <Button type="primary" :disabled="btnDisabled" class="invoice-footer-btn" @click="invoicePost('passLog')">确定</Button>
        </div>
        <div class="invoice-footer-right"></div>
      </div>
    </div>
    <!-- 图片预览 -->
    <full-diag :isShow="showFullImg" @close="toggleFullImg(false)">
      <div class="full-img-content">
        <!-- <img :src="invoiceList[6] === undefined ? '' : invoiceList[6].value" alt=""> -->
        <!-- detailData.accessory_url -->
        <img :src="fullImgUrl" alt="营业执照">
      </div>
    </full-diag>
    <!-- 驳回弹窗 -->
    <simple-diag
      :isShow="rejectDiag"
      :title="'驳回'"
      :width="'400px'"
      :htm="true"
      :disabled="diagDisabled"
      @confirm="confirm"
      @close="toggleDelDiag(false)">
      <template>
        <div class="reject-diag-content">
          <div class="reject-item__label label-request">驳回原因</div>
          <div class="reject-item__value">
            <count-area :value="''" @changeVal="updateReason"></count-area>
          </div>
        </div>
      </template>
    </simple-diag>
  </div>
</template>
<script>
import detailHeader from './components/detailHeader'
import detailInviceInfo from './components/detailInviceInfo'
import pageTable from '@/components/pageCom/pageTable'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import invoiceTableMixin from './components/invoiceTableMixin.js'
import yjhUpload from '@/components/yjhUpload'
import fullDiag from '@/components/dialogs/fullDiag'
import simpleDiag from '@/components/dialogs/simpleDiag'
import countArea from '@/components/countArea'
import { downImg, downFile } from '@/utils/file'
import { getInvoiceDetail, getInvoiceDetailTable, getInvoiceDetailExamine, getInvoiceDetailLogistics, getivoiceDetailGy, getInvoiceDetailTableGy, getInvoiceDetailExamineGy, getInvoiceDetailLogisticsGy } from '@/api/invoiceManage'
export default {
  name: 'invoiceDetailPage',
  components: {
    detailHeader, detailInviceInfo,
    pageTable,
    yjhUpload, countArea,
    fullDiag, simpleDiag
  },
  mixins: [pageTableMixin, invoiceTableMixin],
  data() {
    return {
      pageLoading: true, // 页面loading
      showFileRequerst: false, // 上传文件-上传错误
      rejectDiag: false, // 驳回弹窗
      showFullImg: false, // 图片预览
      btnDisabled: false, // 通过/驳回/确定-按钮禁用状态
      diagDisabled: false, // 弹窗-按钮金庸状态
      // 状态栏数据
      invoiceType: {}, // 发票状态：0:审核中 1:开票中 2:驳回 3:已寄出 4:已作废
      recordType: [{
        name: '待审核',
        icon: 'iconshenhezhong',
        text: '申请单位：',
        cust_name: '', // 申请单位
        invoice_no: '', // 申请编号
        apply_time: '' // 申请日期
      }, {
        name: '待邮寄',
        icon: 'iconshenhezhong',
        text: '申请单位：'
      }, {
        name: '发票已驳回',
        icon: 'iconshanchu1',
        text: '申请单位：'
      }, {
        name: '发票已寄出',
        icon: 'iconshenhetongguo',
        text: '申请单位：'
      }],
      // 详细信息
      invoiceDataList: [
        { name: 'business_type', label: '业务类型', value: '' },
        { name: 'bill_type', label: '开票类型', value: '' },
        { name: 'invoice_type', label: '发票类型', value: '' },
        { name: 'invoice_money', label: '发票金额', value: '' },
        { name: 'invoice_name', label: '名称', value: '' },
        { name: 'invoice_tax_no', label: '税号', value: '' },
        { name: 'invoice_tel', label: '电话', value: '' },
        { name: 'invoice_bank_no', label: '账号', value: '' },
        { name: 'invoice_addr', label: '地址', value: '' },
        { name: 'invoice_bank_name', label: '开户行', value: '' }
      ],
      // 邮寄地址/物流
      invoiceAddressList: [
        { name: 'receive_name', label: '收件人', value: '', request: false },
        { name: 'receive_tel', label: '联系电话', value: '', request: false },
        { name: 'receive_addr', label: '收件地址', value: '', request: false }
        // { name: 'input', label: '运单号', value: '', request: true },
        // { name: 'input', label: '物流公司', value: '', request: true }
      ],
      invoiceAddressListYouJi: [
        { name: 'receive_name', label: '收件人', value: '', request: false },
        { name: 'receive_tel', label: '联系电话', value: '', request: false },
        { name: 'receive_addr', label: '收件地址', value: '', request: false },
        { name: 'input', label: '运单号', value: '', request: true },
        { name: 'input', label: '物流公司', value: '', request: true }
      ],
      // 物流-已寄出
      wuliuAddrssList: [
        { name: 'receive_name', label: '收件人', value: '' },
        { name: 'receive_tel', label: '联系电话', value: '' },
        { name: 'express_company', label: '物流公司', value: '' },
        { name: 'express_no', label: '运单号', value: '' },
        { name: 'invoice_name', label: '发票文件', value: '' },
        { name: 'invoice_addr', label: '收件地址', value: '' },
        { name: 'shunFengUrl', label: '顺丰查询地址', value: 'https://www.sf-express.com/cn/sc', num: '' }
      ],
      // 申请记录-审核意见-(驳回)
      invoiceReject: [
        { name: 'rejectName', label: '审核意见', value: '发票驳回' },
        { name: 'check_text', label: '驳回原因', value: '' }
      ],
      colListSign: ['', 'invoiceTrans', 'invoiceLive', 'invoiceMember'],
      detailType: ['', 'invoice_business_apply_id', 'invoice_live_apply_id', ''],
      returnText: ['', '审核', '填写物流信息', '查看', '查看'], // 返回按钮文字
      detailData: {}, // 页面详情信息数据
      file: null, // 发票文件
      fullImgUrl: '', // 预览url
      check_text: '' // 驳回原因
    }
  },
  computed: {
    baseAPI() {
      return process.env.VUE_APP_BASE_API
    },
    // 操作类型，1:审核；2:填写物流信息；3、查看-已寄出；4、查看-驳回
    routeOperate() {
      return Number(this.$route.params.operate)
    },
    // 选中tab状态 1:交易，2:直播，3:会员
    routeType() {
      return Number(this.$route.params.type)
    },
    // 申请编码
    routeNo() {
      return this.$route.params.id
    },
    // 当前菜单类型 例：invoiceApplyGy / invoiceApplyBj
    changeType() {
      return this.$route.params.changeType
    },
    innerCol() {
      const name = this.changeType
      if (name.includes('Gy')) {
        return this.col[this.colListSign[3]]
      } else {
        return this.col[this.colListSign[this.routeType]]
      }
    },
    // 物流单号
    logNo() {
      return this.invoiceAddressListYouJi[1][1].value
    },
    // 物流公司
    logCompany() {
      return this.invoiceAddressListYouJi[2][0].value
    },
    // 发票类型，1:普通，2:增值税
    invoicePageType() {
      return this.$route.params.invoiceType
    }
  },
  watch: {
    file() {
      if (this.file) {
        this.showFileRequerst = false
      }
    }
  },
  mounted() {
    const title = this.returnText[this.routeOperate]
    this.$store.commit('SET_RETURN_TITLE', title)
    this.$store.commit('SET_RETURN_TYPE', 'normal-clear')
    this.getDetail() // 获取详情
    this.getData()
  },
  methods: {
    initPage() {},
    // 获取详情信息
    getDetail() {
      const params = {
        invoice_no: this.routeNo // 申请编号
      }
      if (this.changeType.includes('Gy')) {
        // 贵阳-获取详情
        getivoiceDetailGy(params).then(res => {
          this.setDetailPublic(res)
        })
      } else {
        // 北京-获取详情
        getInvoiceDetail(params, this.routeType).then(res => {
          this.setDetailPublic(res)
        })
      }
    },
    // 设置详情数据-公共函数
    setDetailPublic(res) {
      const { msg, result } = res
      if (msg === '成功') {
        // 状态栏数据
        this.detailData = result
        this.invoiceType = this.recordType[Number(result.invoice_status)]
        this.invoiceType.cust_name = result.cust_name // 申请单位
        this.invoiceType.invoice_no = result.invoice_no // 申请编号
        this.invoiceType.apply_time = result.apply_time // 申请日期
        // 详细信息
        this.invoiceDataList.map(item => {
          if (item.name === 'invoice_type') {
            item.value = Number(this.invoicePageType) === 1 ? '增值税普通发票' : '增值税专用发票'
          } else if (item.name === 'business_type') {
            const type = ['', '交易结算', '直播会议', '会员服务', '信息调研']
            const name = this.changeType
            if (name.includes('Gy')) {
              item.value = type[4]
            } else {
              item.value = type[this.routeType]
            }
          } else {
            item.value = result[item.name]
          }
        })
        const invoice1 = this.invoiceDataList.splice(0, 2)
        const invoice2 = this.invoiceDataList.splice(0, 2)
        const invoice3 = this.invoiceDataList.splice(0, 2)
        const invoice4 = this.invoiceDataList.splice(0, 2)
        const invoice5 = this.invoiceDataList.splice(0, 2)
        this.invoiceDataList.push(invoice1, invoice2, invoice3, invoice4, invoice5)
        // 邮寄地址
        this.invoiceAddressList.map(item => {
          if (item.name !== 'input' && item.name !== 'shunFengUrl') {
            item.value = result[item.name]
          }
        })
        const address1 = this.invoiceAddressList.splice(0, 2)
        const address2 = this.invoiceAddressList.splice(0, 2)
        const address3 = this.invoiceAddressList.splice(0, 2)
        // const address4 = this.invoiceAddressList.splice(0, 2)
        this.invoiceAddressList.push(address1, address2, address3)
        // 物流信息-已邮寄
        if (this.invoiceType.name === '发票已寄出') {
          this.invoiceAddressListYouJi = this.wuliuAddrssList
        }
        // 物流信息-待邮寄
        this.invoiceAddressListYouJi.map(item => {
          if (item.name !== 'input' && item.name !== 'shunFengUrl') {
            item.value = result[item.name]
          }
          // 快递自动跳转填充
          if (item.name === 'shunFengUrl') {
            item.num = result.express_no
          }
        })
        const addressYj1 = this.invoiceAddressListYouJi.splice(0, 2)
        const addressYj2 = this.invoiceAddressListYouJi.splice(0, 2)
        const addressYj3 = this.invoiceAddressListYouJi.splice(0, 2)
        const addressYj4 = this.invoiceAddressListYouJi.splice(0, 2)
        this.invoiceAddressListYouJi.push(addressYj1, addressYj2, addressYj3, addressYj4)
        // 申请记录-驳回-审核意见
        this.invoiceReject[1].value = result.check_text
        const invoiceReject1 = this.invoiceReject.splice(0, 2)
        this.invoiceReject.push(invoiceReject1)
        this.pageLoading = false
        if (this.routeOperate <= 2) {
          document.querySelectorAll('.detail-right-content__top')[0].style.maxHeight = document.body.offsetHeight - 352 + 'px'
        } else {
          document.querySelectorAll('.detail-right-content__top')[0].style.maxHeight = document.body.offsetHeight - 292 + 'px'
        }
        this.getData()
      } else {
        this.pageLoading = false
        this.$Message.info(msg)
      }
    },
    // 获取账单详情
    getData(type) {
      this.tableLoading = true
      if (type) {
        return
      }
      const _this = this
      setTimeout(() => {
        const id = _this.detailData.id
        if (_this.changeType.includes('Gy')) {
          // 贵阳-账单详情
          getInvoiceDetailTableGy(id).then(res => {
            _this.setTablePublic(res)
          })
        } else {
          // 北京-账单详情
          getInvoiceDetailTable(id, _this.routeType).then(res => {
            _this.setTablePublic(res)
          })
        }
      }, 1000)
    },
    // 设置账单数据-公共函数
    setTablePublic(res) {
      const _this = this
      const { msg, result } = res
      if (msg === '成功') {
        this.tableData = result.data
      } else {
        this.$Message.info(msg)
      }
      setTimeout(() => {
        _this.tableLoading = false
      }, 1000)
    },
    // 选文件
    handleUpload(file) {
      this.file = file
    },
    // 文件上传失败提示
    changeTips(type) {
      this.showFileRequerst = type
    },
    // 预览-发票
    toggleInvoiceImg(flag) {
      this.fullImgUrl = this.detailData.invoice_file_path
      this.showFullImg = flag
    },
    // 下载-发票
    downloadInvoiceImg() {
      const url = this.detailData.invoice_file_path
      const urlName = this.detailData.invoice_file_path.split('/')
      if (url === undefined || url === '') {
        this.$Message.info('图片地址出错')
        return
      }
      const name = urlName[urlName.length - 1]
      downImg(url, name)
      // const url = this.detailData.invoice_file_path
      // window.open(url)
    },
    // 预览-营业执照
    toggleFullImg(flag, url = '') {
      this.fullImgUrl = url
      this.showFullImg = flag
    },
    // 下载-营业执照
    downloadImg() {
      const url = this.detailData.accessory_url
      const urlName = this.detailData.accessory_url.split('/')
      if (url === undefined || url === '') {
        this.$Message.info('图片地址出错')
        return
      }
      const name = urlName[urlName.length - 1]
      downImg(url, name)
    },
    // 审核按钮
    invoicePost(type) {
      // type: 1、通过，2、驳回，passLog、填写物流信息
      this.btnDisabled = true
      if (type === '1' || type === '2') { // 审核-驳回/通过
        if (type === '1' && !this.file) { // 审核-通过
          // this.showFileRequerst = true
          this.btnDisabled = false
          this.$Message.info('请选择上传发票文件')
          return
        }
        var formData = new FormData()
        formData.append('invoice_no', this.routeNo)
        formData.append('is_pass', type)
        formData.append('check_text', this.check_text)
        formData.append('file', this.file)
        if (this.changeType.includes('Gy')) {
          // 贵阳-一审
          getInvoiceDetailExamineGy(formData).then(res => {
            this.setOneExaminePublic(res, type)
          })
        } else {
          // 北京-一审
          getInvoiceDetailExamine(formData, this.routeType).then(res => {
            this.setOneExaminePublic(res, type)
          })
        }
      } else if (type === 'passLog') { // 填写物流信息-确定
        if (!this.logNo) {
          this.$Message.info('请填写运单号')
          this.btnDisabled = false
          return
        }
        if (!this.logCompany) {
          this.$Message.info('请填写物流公司')
          this.btnDisabled = false
          return
        }
        const params = {
          invoice_no: this.routeNo, // 申请编号
          express_company: this.logCompany, // 物流公司
          express_no: this.logNo // 运单号
        }
        if (this.changeType.includes('Gy')) {
          // 贵阳-二审
          getInvoiceDetailLogisticsGy(params).then(res => {
            this.setTwoExaminePublic(res, type)
          })
        } else {
          // 北京-二审
          getInvoiceDetailLogistics(params, this.routeType).then(res => {
            this.setTwoExaminePublic(res, type)
          })
        }
      }
    },
    // 一审-公共函数
    setOneExaminePublic(res, type) {
      if (res.msg === '成功') {
        const _this = this
        const successMsg = type === '1' ? '审核成功' : '驳回成功'
        _this.$Message.info(successMsg)
        if (type === '2') {
          this.toggleDelDiag(false)
        }
        setTimeout(() => {
          _this.pageReturn()
        }, 200)
        this.check_text = '' // 清空驳回原因
      } else {
        this.$Message.info(res.msg)
        this.btnDisabled = false
      }
      this.diagDisabled = false
    },
    // 二审-公共函数
    setTwoExaminePublic(res) {
      if (res.msg === '成功') {
        const _this = this
        _this.$Message.info('提交成功')
        setTimeout(() => {
          _this.pageReturn()
        }, 200)
      } else {
        this.$Message.info(res.msg)
      }
    },
    // 驳回原因赋值
    updateReason(val) {
      this.check_text = val
    },
    // 驳回-弹窗-确定
    confirm() {
      this.diagDisabled = true
      this.check_text = this.check_text.replace(/\s+/g, '')
      if (!this.check_text) {
        this.$Message.info('驳回原因不能为空')
        this.diagDisabled = false
      } else {
        this.invoicePost('2')
      }
    },
    // 关闭/打开驳回弹窗
    toggleDelDiag(type) {
      this.rejectDiag = type
    },
    // 返回上一页
    pageReturn() {
      this.$store.commit('SET_RETURN_FULLURL', localStorage.getItem('returnPath'))
      this.$router.push({
        path: localStorage.getItem('returnPath')
      })
    },
    // 导出明细
    changeExport() {
      // 5开票申请-交易结算—账单明细
      // 7开票申请-直播会议-账单明细
      // 9开票申请-会员-账单明细
      // 11调研-账单明细
      const exportType = {
        detailBj: ['', '5', '7', '9'], // 账单明细-北京
        detailGy: ['', '11'] // 账单明细-贵阳
      }
      const url = process.env.VUE_APP_BASE_API + '/invoice/export_excel'
      const type = this.changeType.includes('Bj') ? exportType.detailBj[this.routeType] : exportType.detailGy[this.routeType]
      const paramsType = ['', 'invoice_business_apply_id', 'invoice_live_apply_id', 'invoice_hy_apply_id']
      const name = this.changeType.includes('Bj') ? paramsType[this.routeType] : 'invoice_report_apply_id'
      const params = {
        table_type: type,
        [name]: this.detailData.id
      }
      downFile(url, params)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.invoice-detail-wrap {
  position: relative;
}
.invoice-detail-left {
  position: relative;
  width: 780px;
  z-index: 1;
}
.invoice-detail-right {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  top: 79px;
  z-index: 0;
  .invoice-detail-right-content {
    width: 990px;
    margin: auto;
    display: flex;
    justify-content: flex-end;
  }
  .detail-right-content {
    width: 210px;
  }
  .detail-right-content__top {
    overflow: auto;
  }
  .detail-right-content__top,
  .detail-right-content__bottom {
    background: $white;
    padding: 16px 10px 0 10px;
    box-shadow: 0px 2px 4px 0px rgba(135, 150, 176, 0.06);
  }
  .detail-right-content__bottom {
    margin-top: 10px;
  }
  .invoice-detail-time-content {
    margin-top: 20px;
  }
  .invoice-detail-right__title {
    font-size: 14px;
    color: $fontBlack;
    font-weight: 400;
    margin-bottom: 10px;
  }
  .invoice-detail-img {
    width: 190px;
    height: 120px;
    border: solid 1px $borderGreyColor;
  }
  .invoice-detail-img__btn {
    text-align: right;
  }
  .invoice-detail-right__btn {
    color: $blue;
    margin: 10px 0;
    display: inline-block;
    cursor: pointer;
    margin-left: 20px;
    text-decoration: underline;
  }
  /deep/ .ivu-timeline-item-head-blue {
    border: none !important;
    background: $fontGray !important;
  }
  /deep/ .ivu-timeline-item-head {
    width: 6px !important;
    height: 6px !important;
    left: 4px;
  }
  /deep/ .ivu-timeline-item-tail {
    // height: 142%;
    border-left: 2px solid $timeLineColor;
    // left: 6px;
    // top: -7px;
  }
  .invoice-detail-time {
    color: $fontBlack;
  }
  .invoice-detail-time-type {
    margin-top: 10px;
    color: $fontBlack;
    font-weight: 600;
  }
  .invoice-detail-time-tips {
    margin-top: 10px;
    color: $fontGray;
    line-height: 1.5;
    word-break: break-all;
  }
}
.apply-detail-content {
  background: $white;
  box-shadow: 0px 2px 6px 0px rgba(135, 150, 176, 0.08);
  color: $fontBlack;
}
.apply-detail-bottom {
  padding: 40px;
  font-size: 12px;
  .etail-bottom-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .apply-detail-btn {
    font-size: 12px;
    color: $blue;
  }
  .apply-detail-bottom__title {
    font-size: 14px;
    font-weight: 400;
  }
  .apply-detail-bottom__detail {
    margin-bottom: 10px;
  }
  .apply-detail__btn {
    color: $blue;
    text-decoration:underline;
    margin-top: 5px;
  }
  .detail-content-bolck {
    border-bottom: solid 1px $border;
  }
  .detail-content-bolck__none {
    text-align: center;
    padding-top: 52px;
    padding-bottom: 50px;
  }
  .detail-content-bolck__table {
    padding-bottom: 20px;
    border-bottom: none;
  }
  /deep/ .v-table-views .v-table-title-cell {
    padding-right: 0 !important;
    color: $fontBlack;
  }
  .invoice-data-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 24px;
    & li {
      display: flex;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 20px;
      & > div {
        display: flex;
        align-items: flex-start;
        width: 50%;
      }
      &:last-child {
        margin-bottom: 30px;
      }
    }
  }
  .invoice-label,
  .invoice-value {
    display: inline-block;
    word-break: break-all;
  }
  .invoice-label {
    width: 80px;
    text-align: right;
    &:after {
      content: ':'
    }
    margin-right: 10px;
  }
  .invoice-value {
    width: 300px;
  }
  .invoice-value-file {
    display: flex;
    align-items: flex-start;
  }
  .invoice-value-btn {
    margin-left: 20px;
    min-width: 65px;
    color: $blue;
    text-decoration: underline;
    & > em:last-child {
      margin-left: 16px;
    }
  }
  .invoice-address {
    & > li {
      width: 50%;
    }
  }
}
.apply-detail-bottom-file {
  padding-bottom: 0;
}
/deep/ .v-table-header:before {
  height: 35px;
}
.invoice-item__value {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 40px;
  .invoice-label {
    width: auto;
    margin-left: 20px;
  }
  /deep/ .link-btn {
    margin-bottom: 10px;
    margin-left: 10px;
    text-decoration: underline;
  }
  .invoice-file-tips {
    position: absolute;
    bottom: 15px;
    left: 85px;
  }
  .icontishi {
    position: relative;
    top: 1px;
    color: $tipsColor;
    margin-right: 3px;
  }
}
.invoice-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  // min-width: 1200px;
  height: 60px;
  background: $white;
  z-index: 2;
  box-shadow: 0px -1px 3px 0px rgba(144, 164, 183, 0.22);
  & .invoice-footer-content {
    width: 1000px;
    margin: 0 auto;
    height: 100%;
    text-align: right;
    display: flex;
    justify-content: flex-end;
  }
  .invoice-footer-left {
    width: 780px;
  }
  .invoice-footer-right {
    width: 230px;
  }
  & .invoice-footer-btn {
    &:first-child {
      margin-right: 20px;
    }
    margin: 16px 0;
  }
}
.invoice-log {
  display: flex;
  align-items: flex-end;
  &__btn {
    color: $blue;
    display: inline-block;
    cursor: pointer;
    margin-left: 16px;
    text-decoration: underline;
  }
  & > img {
    width: 150px;
    height: 100px;
    border: solid 1px $borderGreyColor;
  }
}
.reject-diag-content {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  .reject-item__label {
    position: relative;
    text-align: right;
    height: 18px;
    width: 80px;
    &:after {
      content: ':';
      margin-right: 10px;
    }
  }
}
.time-last {
  /deep/ .ivu-timeline-item-head-blue {
    border: none !important;
    background: $blue !important;
  }
}
</style>
